
import { Injectable } from '@angular/core';
import {  Headers, RequestOptionsArgs } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpClient } from '@angular/common/http';
import { Txn_Income } from '../models/Txn_Income';

@Injectable()

export class Income_Service {
  private readonly Endpoint = '/api';
  headers: any;
  constructor(
    //private http: HttpClient,
    private http: HttpClient) {
    this.headers = new Headers({ 'Content-Type': 'application/json' });
    this.headers.append('Content-Type', 'application/json');
    let authToken = localStorage.getItem('auth_token');
    this.headers.append('Authorization', `Bearer ${authToken}`);
  }

  Create_Income_Contract(txn: Txn_Income) {
    console.log("Income sevice, value date --> " + txn.value_date)
    return this.http.post(this.Endpoint + '/Txn_Income/', txn, { headers: this.headers });
  }

  Create_Income_Contract_File(txn: any) {
    return this.http.post(this.Endpoint + '/Txn_Income/Create_Income_File', txn, { headers: this.headers });
  }

  getIncomes(IncomeGL: string, fromDate: string, toDate:string)
  {
    return this.http.get(this.Endpoint + '/Txn_Income?IncomeGL=' + IncomeGL + '&fromDate=' + fromDate + '&toDate=' + toDate , { headers: this.headers });
  }
  updateIncome(exp: Txn_Income) {
    console.log('inside the Income update');
    console.log(exp);
    return this.http.post(this.Endpoint + '/Txn_Income/updateIncome/', exp);

  }
  deleteIncome(trn_ref_no: string) {
    console.log(trn_ref_no);
    return this.http.delete(this.Endpoint + '/Txn_Income?trn_ref_no=' + trn_ref_no + "&username=test", { headers: this.headers });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/Acc_Income_Service.ts